import {
  // topMainBg,
} from './index';

const topMain = () => {
  if (document.querySelector("body#pageTop") !== null) {



    let sW = window.innerWidth;

    let sec = document.querySelector("#jsSecMain")

    let firstWrap = sec.querySelector(".js-first-wrap")
    let fLogoBox = firstWrap.querySelector(".js-logo-box")

    let conceptCopy = document.querySelector("#jsConceptCopy")
    let gs = conceptCopy.querySelectorAll("g")

    let bgWrap = sec.querySelector(".js-bg-wrap")
    let bgImg = bgWrap.querySelector(".js-img")
    let bgCover = bgWrap.querySelector(".js-cover")

    let mainTopWrap = sec.querySelector(".js-main-top-wrap")
    let tBgArea = mainTopWrap.querySelector(".js-bg-area")
    let tLogoBox = mainTopWrap.querySelector(".js-logo-box")


    gs.forEach((element, index) => {

      if (index == 0) {

        let paths = element.querySelectorAll("path")

        gsap.set(paths, {
          x: 80,
          y: -100,
          autoAlpha: 0,
          filter: 'blur(8px)',
        })

        gsap.to(paths, {
          x: 0,
          y: 0,
          autoAlpha: 1,
          filter: 'blur(0px)',
          ease: "none",
          duration: 2.0,
          ease: "power3.out",
          stagger: {
            from: "random",
            each: 0.1,
          }
        }, 1)

      } else if (index == 1) {
        let paths = element.querySelectorAll("path")
        let polygons = element.querySelectorAll("polygon")
        let rects = element.querySelectorAll("rect")
        let pathall = [...paths, ...polygons, ...rects];
        // console.log(pathall)
        gsap.set(pathall, {
          x: 80,
          y: -100,
          autoAlpha: 0,
          filter: 'blur(8px)',
        })

        gsap.to(pathall, {
          x: 0,
          y: 0,
          autoAlpha: 1,
          filter: 'blur(0px)',
          ease: "none",
          duration: 2.0,
          ease: "power3.out",
          stagger: {
            from: "random",
            each: 0.1,
          }
        }, 1)

      } else if (index == 2) {
        gsap.set(element, {
          autoAlpha: 0,
          filter: 'blur(8px)',
        })
        gsap.to(element, {
          autoAlpha: 1,
          filter: 'blur(0px)',
          ease: "none",
          duration: 2.0,
          ease: "power3.out",
        }, 2)
      }

    });


    if (sW > 750) {

      setTimeout(() => {
        firstWrap.classList.add('bg-none')
        fLogoBox.classList.add('none')
        tLogoBox.classList.add('act')
      }, 4000);

      setTimeout(() => {
        bgImg.classList.add('act')
      }, 4000);

      setTimeout(() => {
        bgCover.classList.add('act')
      }, 7000);

      setTimeout(() => {
        tBgArea.classList.add('act')
      }, 8000);

      setTimeout(() => {
        firstWrap.classList.add('none')
        tBgArea.classList.add('fix')
        bgImg.classList.add('fix')
        // topMainBg()
      }, 9000);

    } else {

      setTimeout(() => {
        firstWrap.classList.add('bg-none')
        fLogoBox.classList.add('none')
        tLogoBox.classList.add('act')
      }, 4000);

      setTimeout(() => {
        bgImg.classList.add('act')
      }, 4000);

      setTimeout(() => {
        bgCover.classList.add('act')
      }, 7000 - 2000);

      setTimeout(() => {
        tBgArea.classList.add('act')
      }, 8000 - 2000);

      setTimeout(() => {
        firstWrap.classList.add('none')
        tBgArea.classList.add('fix')
        bgImg.classList.add('fix')
        // topMainBg()
      }, 9000 - 2000);

    }




  }
}
export default topMain;